import React, { useState, useEffect, useCallback } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Header from "../../components/Header";
import Section from "../../components/Section";
import SuccessNotification from "../../components/Notifications/SuccessNotification";
import SuccessProcess from '../../components/Notifications/SuccessProcess';
import ErrorNotification from "../../components/Notifications/ErrorNotification";
import LoginNotification from "../../components/Notifications/LoginNotification";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faSave,
    faRotate,
    faCircleArrowLeft,
    faXmark,
    faEyeSlash,
    faEye,
} from "@fortawesome/free-solid-svg-icons";
import apiClient from "../../axios";

const TechnicianForm = ({ handleLogout }) => {
    const navigate = useNavigate();
    const { id } = useParams();
    const [description, setDescription] = useState("");
    const [contract, setContract] = useState("");
    const [contractSearch, setContractSearch] = useState("");
    const [contractData, setContractData] = useState([]);
    const [isContractSelected, setIsContractSelected] = useState(false);
    const [max_user, setUsuario] = useState("");
    const [flag_active, setFlagActive] = useState(false);
    const [ip_access, setIpAccess] = useState("");
    const [url_access, setUrlAccess] = useState("");
    const [port_access, setpPortAccess,] = useState(0);
    const [user_manager, setUserManager,] = useState("");
    const [pass_manager, setPassManager,] = useState("");
    const [ipFenixWs, setIpFenixWs,] = useState("");
    const [portFenixWs, setPortFenixWs,] = useState("");
    const [isSuccessVisible, setIsSuccessVisible] = useState(false);
    const [isErrorVisible, setIsErrorVisible] = useState(false);
    const [errorsMessage, setErrorMessage] = useState({});
    const [isLoginVisible, setIsLoginVisible] = useState(false);
    const [errors, setErrors] = useState({});
    const [showPassword, setShowPassword] = useState(false);
    const [notificationBlock, setNotificationBlock] = useState(false);
    const [messageBlock, setMessageBlock] = useState(false);

    useEffect(() => {
        if (id) {
            const fetchProduct = async () => {
                try {
                    const response = await apiClient.get(`/servers/${id}`);
                    console.log(response.data);
                    setDescription(response.data.description);
                    //setContract(`${response.data.contract}`);
                    setContractSearch(response.data.contract);
                    setUsuario(response.data.maxUser);
                    setFlagActive(response.data.flagActive);
                    setIpAccess(response.data.ipAccess);
                    setUrlAccess(response.data.urlAccess);
                    setpPortAccess(response.data.portAccess);
                    setUserManager(response.data.userManager);
                    setPassManager(response.data.passManager);
                } catch (error) {
                    console.error("Error al cargar el Servidor", error);
                }
            };
            fetchProduct();
        }
    }, [id]);

    /*  const toggleSwitch = () => {
          setFlagActive((prev) => !prev);
      };*/

    const toggleShowPassword = () => {
        setShowPassword((prevShowPassword) => !prevShowPassword);
    };
    const validateFields = () => {
        let validationErrors = {};
        if (!description) validationErrors.description = "El Campo es Obligatorio";
        if (!max_user) validationErrors.max_user = "El Campo es Obligatorio";
        return validationErrors;
    };
    const handleCloseBlock = () => {
        setNotificationBlock(false);
    };
    const handleSearchContract = useCallback(async (page = 1) => {
        try {
            const params = new URLSearchParams();
            if (contractSearch) params.append('search', contractSearch);

            const response = await apiClient.get(`/contracts?${params.toString()}&page=${page}`);

            if (Array.isArray(response.data.results)) {
                setContractData(response.data.results);
            } else {
                setContractData([response.data.results]);
            }
        } catch (error) {
            if (error.response && error.response.status === 401) {
                setIsLoginVisible(true);
            }
        }
    }, [contractSearch]);

    useEffect(() => {
        if (!isContractSelected) {
            const delayDebounceFn = setTimeout(() => {
                if (contractSearch) {
                    handleSearchContract();
                }
            }, 200);

            return () => clearTimeout(delayDebounceFn);
        }
    }, [contractSearch, handleSearchContract, isContractSelected]);

    const handleInputChangeContract = (e) => {
        const value = e.target.value;
        if (/^\d*$/.test(value)) {
            setContractSearch(value);
        }

        if (isContractSelected) {
            setIsContractSelected(false);
        }

        if (value.trim() === "") {
            setContractData([]);
        }
    };

    const handleContractSelect = (contractNumber, contractName) => {
        setContractSearch(contractName);
        setContract(`${contractNumber}`);
        setContractData([]);
        setIsContractSelected(true);
    };

    const handleSave = async () => {
        const validationErrors = validateFields();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }
        try {
            let response;
            if (id) {
                const payloadUpdate = {
                    description,
                    max_user,
                    ip_access,
                    url_access,
                    port_access,
                    user_manager,
                    pass_manager,
                    ipFenixWs,
                    portFenixWs
                };
                response = await apiClient.patch(
                    `/servers/${id}`,
                    payloadUpdate
                );
                if (response.status === 200) {
                    setIsSuccessVisible(true);
                    setIsErrorVisible(false);
                    setIsLoginVisible(false);
                    setErrors({});
                    setTimeout(() => {
                        setIsSuccessVisible(false);
                    }, 4000);
                    navigate("/ServerList");
                }
            } else {
                const payload = {
                    description,
                    contract,
                    max_user,
                    flag_active,
                    ip_access,
                    url_access,
                    port_access,
                    user_manager,
                    pass_manager,
                    ipFenixWs,
                    portFenixWs
                };
                response = await apiClient.post("/servers", payload);
                if (response.status === 201) {
                    setIsSuccessVisible(true);
                    setIsErrorVisible(false);
                    setErrors({});
                    setTimeout(() => {
                        setIsSuccessVisible(false);
                    }, 4000);
                    navigate("/ServerList");
                }
            }
        } catch (error) {
            if (error.response && error.response.status === 401) {
                setIsLoginVisible(true);
            } else if (error.response?.data?.message.startsWith("CONTRACT_ALREADY_IN_USE")) {
                setMessageBlock("El Nro. Contrato ingresado ya esta asociado a un Servidor.");
                setNotificationBlock(true);
            } else if (error.response?.data?.message.startsWith("\"max_user\" must be less than or equal to 99")) {
                setErrorMessage("El Nro. de Usuarios máximo es de 99.");
                setIsLoginVisible(false);
                setIsErrorVisible(true);
                setIsSuccessVisible(false);
                setTimeout(() => {
                    setIsErrorVisible(false);
                }, 4000);
            }
            else {
                setErrorMessage("Oops!. Ocurrio un error al crear el Servidor");
                setIsLoginVisible(false);
                setIsErrorVisible(true);
                setIsSuccessVisible(false);
                setTimeout(() => {
                    setIsErrorVisible(false);
                }, 4000);
            }
        }
    };

    return (
        <div className="home-container">
            <Header onLogout={handleLogout} title="Servidor" />
            <Section>
                <div className="button-return-container">
                    <FontAwesomeIcon
                        className="basic-shortcut-icon"
                        style={{ cursor: "pointer" }}
                        icon={faCircleArrowLeft}
                        onClick={(e) => {
                            e.stopPropagation();
                            navigate("/ServerList");
                        }}
                    />
                </div>
            </Section>
            <div className="moduleNew-form-container">
                <h3 className="basic-info-form-title">Información del Servidor</h3>
                <div className="basic-info-form-grid">
                    <div className="basic-info-form-group">
                        <label style={{ color: errors.description ? "red" : "revert-layer" }}>
                            Descripción
                        </label>
                        <input
                            type="text"
                            placeholder="Descripción"
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}

                        />
                        {errors.description && <p className="error-message">{errors.description}</p>}
                    </div>
                    <div className="basic-info-form-group">
                        <label>
                            Nro. Contrato
                        </label>
                        <input
                            type="text"
                            placeholder="Nro. Contrato"
                            value={contractSearch}
                            onChange={handleInputChangeContract}
                            //onChange={(e) => setContract(e.target.value)}
                            /*onChange={(e) => {
                                const value = e.target.value;
                                if (/^\d*$/.test(value)) {
                                    setContract(value);
                                }
                            }}*/
                            readOnly={!!id}
                        />
                        {contractData.length > 0 && (
                            <div className="search-results2">
                                <ul>
                                    {contractData.map((item) => (
                                        <li key={item.id} onClick={() => handleContractSelect(item.numCont, item.numCont)}>
                                            {item.numCont}
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        )}
                    </div>
                    <div className="basic-info-form-group">
                        <label style={{ color: errors.max_user ? "red" : "revert-layer" }}>
                            Nro. Usuarios
                        </label>
                        <input
                            type="text"
                            placeholder="Nro. Usuarios"
                            value={max_user}
                            //onChange={(e) => setUsuario(e.target.value)}
                            onChange={(e) => {
                                const value = e.target.value;
                                if (/^\d{0,2}$/.test(value)) {
                                    setUsuario(value);
                                }
                            }}
                        />
                        {errors.max_user && <p className="error-message">{errors.max_user}</p>}
                    </div>
                    <div className="basic-info-form-group">
                        <label>
                            Host
                        </label>
                        <input
                            type="text"
                            placeholder="Host"
                            value={ip_access}
                            //onChange={(e) => setIpAccess(e.target.value)}
                            onChange={(e) => {
                                const value = e.target.value;
                                if (/^(?!.*\.\.)[\d.]*$/.test(value)) {
                                    setIpAccess(value);
                                }
                            }}
                        />
                    </div>
                    <div className="basic-info-form-group">
                        <label>
                            URL de Acceso
                        </label>
                        <input
                            type="text"
                            placeholder="URL de Acceso"
                            value={url_access}
                            onChange={(e) => setUrlAccess(e.target.value)}
                        />
                    </div>
                    <div className="basic-info-form-group">
                        <label>
                            Puerto de Acceso
                        </label>
                        <input
                            type="text"
                            placeholder="Puerto de Acceso"
                            value={port_access}
                            //onChange={(e) => setpPortAccess(e.target.value)}
                            onChange={(e) => {
                                const value = e.target.value;
                                if (/^\d{0,7}$/.test(value)) {
                                    setpPortAccess(value);
                                }
                            }}
                        />
                    </div>
                    <div className="basic-info-form-group">
                        <label>
                            Usuario de Administrador
                        </label>
                        <input
                            type="text"
                            placeholder="Usuario"
                            value={user_manager}
                            onChange={(e) => setUserManager(e.target.value)}
                        />
                    </div>
                    <div className="basic-info-form-group">
                        <label>
                            Clave de Administrador
                        </label>
                        <div className="password-input-container">
                            <input
                                className="text-box-login2"
                                type={showPassword ? "text" : "password"}
                                value={pass_manager}
                                onChange={(e) => setPassManager(e.target.value)}
                                placeholder="Contraseña"
                            />
                            <FontAwesomeIcon
                                icon={showPassword ? faEyeSlash : faEye}
                                className="password-toggle-icon2"
                                onClick={toggleShowPassword}
                            />
                        </div>
                    </div>
                    <div className="basic-info-form-group">
                        <label>
                            IP Fenix WS
                        </label>
                        <input
                            type="text"
                            placeholder="IP Fenix WS "
                            value={ipFenixWs}
                            onChange={(e) => setIpFenixWs(e.target.value)}
                        />
                    </div>
                    <div className="basic-info-form-group">
                        <label>
                            Puerto Fenix WS
                        </label>
                        <input
                            type="text"
                            placeholder="Puerto Fenix WS"
                            value={portFenixWs}
                            onChange={(e) => setPortFenixWs(e.target.value)}
                        />
                    </div>
                </div>
                <div className="basic-form-footer">
                    <button
                        className="basic-custom-button"
                        onClick={(e) => {
                            e.stopPropagation();
                            navigate("/ServerList");
                        }}
                    >
                        <FontAwesomeIcon icon={faXmark} className="basic-shortcut-icon" />
                        Cancelar
                    </button>
                    <button
                        className="basic-custom-button"
                        onClick={handleSave}
                    >
                        <FontAwesomeIcon
                            icon={id ? faRotate : faSave}
                            className="basic-shortcut-icon"
                        />
                        {id ? "Actualizar" : "Guardar"}
                    </button>
                </div>
            </div>
            <SuccessNotification
                message={
                    id
                        ? "El Servidor se ha Actualizado Correctamente."
                        : "El Servidor se ha Creado Correctamente."
                }
                isVisible={isSuccessVisible}
                onClose={() => setIsSuccessVisible(false)}
            />
            <ErrorNotification
                message={errorsMessage}
                isVisible={isErrorVisible}
                onClose={() => setIsErrorVisible(false)}
            />
            <LoginNotification
                message="Vuele a iniciar sesión"
                isVisible={isLoginVisible}
                onClose={() => setIsLoginVisible(false)}
                onLogout={handleLogout}
            />
            {notificationBlock && (
                <SuccessProcess
                    enca={true}
                    message={`No se puede Crear el Servidor debido a : ${messageBlock}`}
                    isVisible={notificationBlock}
                    onClose={handleCloseBlock}
                    redirectOnOk={true}
                    pageNavigate={"/ServerList"}
                    whatsApp={false}
                />
            )}
        </div>
    );
};

export default TechnicianForm;
